import { Component, Input } from '@angular/core';

import { WorldMapCountry, WorldMapFeature } from '../../models/worldmap-model';

import { CommonModule } from '@angular/common';
import { bubbleScale } from '../../../helpers/chartHelpers';

@Component({
  selector: '[chart-bubble]',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg:g class="symbol-bubble-wrapper" [attr.transform]="'translate(' + feature.centroid[0] + ',' + feature.centroid[1] + ')'">
      <svg:circle
        class="symbol-bubble"
        [attr.transform]="'scale(' + radius + ')'"
        [attr.cx]="0"
        [attr.cy]="0"
        [attr.r]="1"
        [attr.stroke-width]="0.5 / radius"
        [attr.fill]="color"
      />
    </svg:g>
  `,
  styleUrls: ['./bubble.component.scss']
})
export class BubbleComponent {
  @Input()
  color: string;

  @Input()
  feature: WorldMapFeature;

  @Input()
  circleSizes: Array<number>;

  //  Public variables to draw the bubbles
  public radius: number;
  public fillColor: string;

  @Input()
  dataRange: Array<number>;

  @Input()
  set country(country: WorldMapCountry) {
    this.radius = bubbleScale(this.dataRange, country.scaledCount ? country.scaledCount : country.count, this.circleSizes);
  }
}
